export default function validateAlphaNumeric(val) {
    return /[a-zA-Z0-9#(][a-zA-Z0-9 '().,#:/\-@_%]*/.test(val);
}



// WEBPACK FOOTER //
// ./src/components/helpers/validation/validateAlphaNumeric.js